import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { messagesSlice, signupSlice, formSlice, surveySlice } from './slices';
import { devToolsOptions } from './devToolsOptions';
import { messagesStackSlice } from './slices/messagesStack.slice';
import { querystringConf } from '../utils/querystringConf';

const reducer = {
	form: formSlice.reducer,
	survey: surveySlice.reducer,
	signup: signupSlice.reducer,
	messages: messagesSlice.reducer,
	messagesStack: messagesStackSlice.reducer,
};
const preloadedState = {};

const logger = createLogger({
	collapsed: true,
});

export const store = configureStore({
	reducer,
	middleware: (getDefaultMiddleware) => {
		const middlewares = getDefaultMiddleware({ thunk: true });
		if (querystringConf('redux_logger') === true) {
			middlewares.concat(logger as any);
		}
		return middlewares;
	},
	devTools:
		process.env.NODE_ENV !== 'production'
			? { ...devToolsOptions, trace: true }
			: false,
	preloadedState,
});

export type IAppState = ReturnType<typeof store.getState>;
export type IAppDispatch = typeof store.dispatch;
